export default __webpack_public_path__ + "e194a4162e06824256ff9e50f774a434.svg";